import React from 'react'
import AppendHead from 'react-append-head'

export const Analytics = () => {
  const environment = process.env.NODE_ENV
  const isStaging = environment === 'staging'
  const isProduction = environment === 'production'

  return (
    <React.Fragment>
      {(isStaging || isProduction) && (
        <AppendHead>
          <script name="gtm" order="0" type="text/javascript">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-594HVV');`}
          </script>
        </AppendHead>
      )}
    </React.Fragment>
  )
}
